export default "__VITE_ASSET__DWwSkIyW__"